import * as R from 'ramda';
import React from 'react';
import {withRouter} from 'react-router-dom';

import {translate} from 'iss/strings';
import {createContractSupplier, deleteContractSupplier, modifyContractSupplier, subscribeToContractSupplier} from 'iss/service/ContractSuppliersService';
import {hasAdminRole} from 'iss/service/PartyService';
import styles from 'iss/styles/ContractSupplierEditor.styl';
import {Button, CancelButton, NewButton, SubmitButton} from 'iss/widgets/Buttons';
import {Checkbox, FormWithState, Input} from 'iss/widgets/Forms';
import {RestResultMessage, SuccessBox} from 'iss/widgets/MessageBox';
import Modal from 'iss/widgets/bootstrap/Modal';
import validators from 'iss/widgets/form/validation/validators';

const ContractSupplierEditor = withRouter(subscribeToContractSupplier(class ContractSupplierEditor extends React.Component {
    state = {
      backendError: null,
    };
    saveSupplier = ({
        id,
        businessId,
        name,
        description,
        serviceInformation,
        otherInformation,
        contactPerson,
        email,
        area,
        preferredSupplier,
        category
    }) => {
        const data = {
            businessId,
            name,
            description,
            serviceInformation,
            otherInformation,
            contactPerson,
            email,
            area,
            preferredSupplier,
            category
        };

        if (this.isNew()) {
            createContractSupplier(data).subscribe((result) => {
                this.props.history.push("/contract-supplier/"+result.id+"?success=true");
            },
            (errorResponse) => this.setState({backendError: errorResponse}));
        } else {
            modifyContractSupplier(id, data).subscribe((result) => {
                this.props.history.push("/contract-supplier/"+result.id+"?success=true");
            },
            (errorResponse) => this.setState({backendError: errorResponse}));
        }
    };

    isDeleted = () => {
        return this.props.supplier.isActive == false;
    };

    isNew = () => {
        return !this.props.supplier.id;
    };

    deleteSupplier = () => {
        deleteContractSupplier(this.props.supplier.id).subscribe(() => this.props.history.push("/contract-suppliers/?deleteSuccess=true"),
          (errorResponse) => this.setState({backendError: errorResponse}));
    };

    insertDecimal = (num) => {
      if (num % num != 0) { return num; }
      return (num * 100 / 100).toFixed(1);
    };

    render() {
        const showSuccessMessage = this.props.history.location.search.indexOf("success=true") != -1;

        return <FormWithState initialValues={this.props.supplier} className="tight-form-controls" onSubmit={this.saveSupplier}>

            <SuccessBox id="submitSuccess" message={showSuccessMessage ? translate('common.savedSuccessfully') : null} />

            <h1>{
                this.isDeleted() ?
                    translate('contractSupplierEditor.deleted') :
                    this.isNew() ?
                        translate('contractSupplierEditor.newTitle') :
                        translate('contractSupplierEditor.editTitle')
            }</h1>

            <Button id="to-supplier-list" link="/contract-suppliers" text={translate('contractSupplierEditor.returnToList')} className={styles.rightFloatButton} />

            <br/>
            { !this.isNew() ?
              <div>
                <h4>{ this.props.supplier.reviewAverage !== null ?
                translate('contractSuppliers.reviewAverage') + ": " + this.insertDecimal(this.props.supplier.reviewAverage) :
                translate('contractSuppliers.noReviewAverage')}</h4>
                <Button id="to-supplier-reviews" link={"/contract-supplier/"+this.props.supplier.id+"/reviews"} text={translate('contractSupplierEditor.reviews')} className={styles.leftFloatButton} />
                <NewButton id="new-contract-supplier-review" link={"/contract-supplier/"+this.props.supplier.id+"/reviews/new"} text={translate('contractSupplierEditor.newReview')} />
              </div>
              : null
            }

            <br/>
            <br/>
            <Input label="domain.contractSupplier.businessId" id="supplier-businessId"
              valuePath="businessId" validate={validators.required} readOnly={(this.isDeleted() || !hasAdminRole())} maxLength="255" showCounter={true} />
            <Input label="domain.contractSupplier.name" id="supplier-name"
              valuePath="name" validate={validators.required} readOnly={(this.isDeleted() || !hasAdminRole())} maxLength="255" showCounter={true}/>
            <Input label="domain.contractSupplier.description" id="supplier-description"
              valuePath="description" readOnly={(this.isDeleted() || !hasAdminRole())} maxLength="1000" showCounter={true}/>
            <Input label="domain.contractSupplier.serviceInformation" id="supplier-serviceInformation"
              valuePath="serviceInformation" readOnly={(this.isDeleted() || !hasAdminRole())} maxLength="1000" showCounter={true}/>
            <Input label="domain.contractSupplier.otherInformation" id="supplier-otherInformation"
              valuePath="otherInformation" readOnly={(this.isDeleted() || !hasAdminRole())} maxLength="1000" showCounter={true}/>
            <Input label="domain.contractSupplier.contactPerson" id="supplier-contactPerson"
              valuePath="contactPerson" readOnly={(this.isDeleted() || !hasAdminRole())} maxLength="100" showCounter={true}/>
            <Input label="domain.contractSupplier.email" id="supplier-email"
              valuePath="email" readOnly={(this.isDeleted() || !hasAdminRole())} maxLength="255" showCounter={true}/>
            <Input label="domain.contractSupplier.area" id="supplier-area"
              valuePath="area" readOnly={(this.isDeleted() || !hasAdminRole())} maxLength="255" showCounter={true}/>
            <Input label="domain.contractSupplier.category" id="supplier-category"
              valuePath="category" readOnly={(this.isDeleted() || !hasAdminRole())} maxLength="1000" showCounter={true}/>
            <Checkbox id="supplier-preferredSupplier" className="text-nowrap" label="domain.contractSupplier.preferredSupplier"
              valuePath="preferredSupplier" disabled={(this.isDeleted() || !hasAdminRole())}/>
            <br/>
            <br/>

            <RestResultMessage id="backendError" result={this.state.backendError} />
            {(!this.isDeleted() && hasAdminRole()) ?
                <div className="form-supplier">
                    <SubmitButton id="save-supplier" text={translate('common.save')} />
                    <CancelButton link="/contract-suppliers" />
                    {!this.isNew() ? <DeleteSupplierButton onChanged={this.deleteSupplier} /> : null}
                </div> :
                null
            }
        </FormWithState>;
    }
}));

class DeleteSupplierButton extends React.Component {
    state = {
      showModal: false,
      backendError: null,
    };
    toggleModal = () => {
      this.setState(R.evolve({showModal: R.not}));
    };
    deleteSupplier = () => {
      const {onChanged} = this.props;
      this.toggleModal();
      onChanged();
    };
    render() {
      return <React.Fragment>
        <Button buttonLook="danger" onClick={this.toggleModal} id="delete-supplier" className={styles.floatButton}>
          {translate('contractSupplierEditor.deleteSupplier')}
        </Button>
        <Modal title={translate('contractSupplierEditor.deleteSupplier')} visible={this.state.showModal} size="medium" onClose={this.toggleModal}>
          {{
            body: <p>{translate('contractSupplierEditor.doYouWantToDelete')}</p>,
            footer: <React.Fragment>
              <CancelButton onClick={this.toggleModal} id="cancel-delete" />
              <Button buttonLook="danger" onClick={this.deleteSupplier} id="confirm-delete">
                {translate('contractSupplierEditor.delete')}
              </Button>
              <RestResultMessage id="deleteGroupError" result={this.state.backendError} />
            </React.Fragment>
          }}
        </Modal>
      </React.Fragment>;
    }
  }

export default ContractSupplierEditor;


// WEBPACK FOOTER //
// ./modules/issFrontend/pages/ContractSupplierEditor.jsx